@if (!showAwaitContent) {
<ng-content></ng-content>
} @if (showAwaitContent) {
<ng-content select=".await-container"></ng-content>
}
